import { compose } from 'recompose';
import { creditNoteAPi,jvApi } from '../../common/base.api';
import CreditNoteDetail from './CreditNoteDetail';
import apiInterceptor from '../../../api/interceptor';

const CreditNoteVoucherDetail = compose(apiInterceptor({ ...creditNoteAPi , updateApi: jvApi.update, }))(CreditNoteDetail);

export default CreditNoteVoucherDetail;
